import React from 'react'

import ContentPage from './ContentPage.jsx'

import es from '../locales/security_es.json'
import en from '../locales/security_en.json'

function Security() {
    return <ContentPage es={es} en={en} />
}

export default Security
